import Heading from 'components/common/Heading';
import AdSourceHeaderContent from 'components/signUpFunnel/Tempo/AdSourceHeaderContent';
import ImageSection from 'components/signUpFunnel/Tempo/ImageSection';
import useQuery from 'hooks/useQuery';

const TempoHeader = () => {
  const { isQueryParamTrue: isAdSource } = useQuery('source', 'ad');
  const { isQueryParamTrue: isSharapova } = useQuery('ms', 'true');

  if (isAdSource) {
    return (
      <div className="relative">
        <AdSourceHeaderContent isSharapova={isSharapova} />
        <ImageSection variant={isSharapova ? 'sharapova' : 'adSource'} />
      </div>
    );
  }

  return (
    <Heading className="mx-auto mb-2 max-w-xl text-center">Let's get to know you a bit!</Heading>
  );
};

export default TempoHeader;
